<script setup lang="ts">

import type { HTMLAttributes } from 'vue';

defineProps<{
  id?: string,
  icons: string[],
  to: string,
  title?: string,
  selected?: boolean
  class?: HTMLAttributes['class'],
}>();
</script>
<template>
  <NuxtLink :id="id" :to="to" :class="['flex group', $props.class]">
    <MenuSubItemContent
      :icons="icons"
      :title="title"
      :selected="selected"
    >
      <template #title>
        <slot name="title">
          {{ title }}
        </slot>
      </template>
    </MenuSubItemContent>
  </NuxtLink>
</template>
